import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from "@mui/material";
import {VideoPreset} from "./VideoPreset";
import {VideoRule} from "./VideoRule";
import makeStyles from "@mui/styles/makeStyles";

const useScriptStyles = makeStyles(theme => ({
    config: {
        height: "100%"
    },
    details: {
        flexGrow: 1,
        height: "calc(100% - 256px)",
        margin: theme.spacing(1),
        overflowX: "hidden",
        overflowY: "auto",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    }
}));

interface IVideoExportDetails {
    config: any
    project: string
}
export function VideoExportDetails({config, project}: IVideoExportDetails) {
    const classes = useScriptStyles();

    if (! config?.video_export) {
        return (
            <Box display="flex">
                <Typography color="error">
                    There are no video export settings for the project so the build system will not be able to put the
                    data into the correct place. To set up the project update the settings in the open project dialog
                    within Cookbook.
                </Typography>
            </Box>
        );
    }
    return (
        <Box className={classes.details}>
            <Typography>
                Extra settings to apply to different export formats and rules on a per file pattern basis.
            </Typography>
            <Accordion>
                <AccordionSummary><Typography>Presets</Typography></AccordionSummary>
                <AccordionDetails>
                    {Object.keys(config.video_export.base.presets).map(preset =>
                        <VideoPreset config={config} key={preset} preset={preset}/>
                    )}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary><Typography>Rules</Typography></AccordionSummary>
                <AccordionDetails>
                    {Object.keys(config.video_export.base.rules).map(rule =>
                        <VideoRule config={config} key={rule} rule={rule}/>
                    )}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}